// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownMenu_root__1lQiZ","content":"DropdownMenu_content__3BNN2","header":"DropdownMenu_header__2hi56","children":"DropdownMenu_children__1C2Iu"};